<div class="container buyerBox">
  <div class="row">
    <div class="heading col-lg-12">
      <h5 class="mb-0">
        Keep your conversation going with {{ receiverInfo?.fullName }}
      </h5>
    </div>
    @if (!bundleLoader) {
      @for (package of packages; track package) {
        <div class="col-lg-4 mt-3">
          @if (screenWidth > 1024) {
            <div 
              class="packageBox"
              [ngClass]="{ disbaled: !package?.price }"
            >
              <input
                type="radio"
                class="d-none"
                [id]="'packageGroup' + package?.id"
                name="packageGroup"
                (change)="changePackage(package)"
                [disabled]="!package?.price"
                [readOnly]="!package?.price"
              />
              <label
                [for]="'packageGroup' + package?.id"
                class="cursor position-relative"
              >
                <h6 class="blue breakWords">
                  {{ package.name }}
                </h6>
                <p class="description darkColor breakWords">{{ package.description }}</p>
                <div class="dCenter flex-column mt-4">
                  <div class="dCenter flex-column">
                    <div class="dCenter">
                      <span class="blue price">{{
                        (package?.price | currency: "USD" | removeDecimal) || 0
                      }}</span>
                    </div>
                    <div class="dCenter">
                      <h4 class="lightBundleBg mb-0 lineThrough">
                        {{ (package?.actualPrice | currency: "USD" | removeDecimal) || 0 }}
                      </h4>
                    </div>
                  </div>
                  <span class="save"
                    >You save {{ package?.savings | currency: "USD" | removeDecimal }}</span
                  >
                </div>
                @for (item of package?.packageProducts; track $index) {
                  <p
                    class="darkColor smallFont descriptionText my-3"
                    [ngClass]="{ cstmEllipses: screenWidth <= 1024 }"
                  >
                    <fa-icon [icon]="faCheckCircle"></fa-icon>
                    {{ item?.limit + " " + item?.name }}
                  </p>
                }
              </label>
            </div>
          }
          @if (screenWidth <= 1024) {
            <div class="packageBox small">
              <input
                type="radio"
                class="d-none"
                [id]="'packageGroup' + package?.id"
                name="packageGroup"
                (change)="selectedBundle = package"
                [disabled]="!package?.price"
                [readOnly]="!package?.price"
              />
              <label
                [for]="'packageGroup' + package?.id"
                class="cursor d-flex align-items-center justify-content-between"
              >
                <div class="left">
                  <h6 class="blue bigFont mb-1 breakWords">
                    {{ package.name }}
                  </h6>
                  <p class="description darkColor breakWords">{{ package.description }}</p>
                  @for (item of package?.packageProducts; track $index) {
                    <p
                      class="darkColor smallFont descriptionText"
                      [ngClass]="{ cstmEllipses: screenWidth <= 1024 }"
                    >
                      <fa-icon [icon]="faCheckCircle"></fa-icon>
                      {{ item?.limit + " " + item?.name }}
                    </p>
                  }
                </div>
                <div class="right">
                  <div class="dCenter flex-column">
                    <div class="priceSection dCenter flex-column">
                      <div class="dCenter align-items-start">
                        <span class="blue price">{{
                          package?.price | currency: "USD" | removeDecimal
                        }}</span>
                      </div>
                      <div class="dCenter">
                        <h6 class="lightBundleBg lineThrough">
                          {{ package?.actualPrice | currency: "USD" | removeDecimal }}
                        </h6>
                      </div>
                    </div>
                    <span class="save">
                      You save {{ package?.savings | currency: "USD" | removeDecimal }}
                    </span>
                  </div>
                </div>
              </label>
            </div>
          }
        </div>
      }
      <div class="col-lg-12 mt-5">
        <button
          class="btnDark float-end"
          [ngClass]="{
            'w-25': (resize.windowSize$ | async)?.width > 1024,
            'w-100': (resize.windowSize$ | async)?.width <= 1024
          }"
          [disabled]="!selectedBundle"
          [ngbTooltip]="!selectedBundle && 'Please select a package first'"
          (click)="submit(); clickedOnSubmit = true"
        >
          Subscribe
        </button>
      </div>
    } @else {
      <div class="mt-5">
        <app-mini-loading></app-mini-loading>
      </div>
    }
  </div>
</div>
